<template>
  <BlNavBarMv :title="title" has-back-button class="faq-header" data-testid="faq-header" @handleBackButtonClick="toPreviousPage" />
</template>

<script>
import {BlNavBarMv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'FaqHeader',
  components: {
    BlNavBarMv,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    toPreviousPage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-header {
  background-color: #3838a8 !important;
  border-bottom: 1px solid #ebebeb;
  position: sticky;
  top: 0;
  &::v-deep .bl-text {
    color: #fff;
  }
  &::v-deep .ico_back_android {
    fill: #fff;
  }
}
</style>
